import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useUserVerification(user: any) {
  // Check if the current user is verified (works for both artists and sponsors)
  const { data: isVerified, isLoading: isVerificationLoading } = useQuery({
    queryKey: ["isUserVerified", user?.id],
    queryFn: async () => {
      if (!user) return false;

      const { data: profiles, error } = await supabase.rpc(
        "get_profiles_by_ids",
        { p_ids: [user.id] },
      );
      if (error || !profiles || profiles.length === 0) return false;

      const profile = profiles[0];

      const isVerified = profile.is_verified === true;
      const expiryDate = profile.verification_expiry
        ? new Date(profile.verification_expiry)
        : null;
      const isStillValid = expiryDate ? new Date() < expiryDate : false;
      return isVerified && isStillValid;
    },
    enabled: !!user,
  });

  // Fetch the current user's role
  const { data: userRole } = useQuery({
    queryKey: ["userRole", user?.id],
    queryFn: async () => {
      if (!user) return null;
      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id)
        .single();
      if (error || !data) return null;
      return data.role;
    },
    enabled: !!user,
  });

  return {
    isArtistVerified: isVerified, // Keep backward compatibility
    isSponsorVerified: isVerified,
    isVerified,
    isVerificationLoading,
    userRole,
  };
}
